module.exports = {"white":"rgb(255, 255, 255)","black":"rgb(0, 0, 0)"};